import {orion, organizations} from '../config/axios'
import {handleError} from "./common";


export const getDeviceList = (token, pag, callback) => {
    orion.get(`entities?type=info&offset=${pag * 20}&options=count`, {
        headers: {
            "x-auth-token": token,
            "FIWARE-Service": "sensor"
        }
    })
        .then(response => {
            callback(response.data, false)
        })
        .catch(error => {
            handleError(error, callback, (token_n) => getDeviceList(token_n, pag, callback));
        })
};


export const UpdateDevice = (token, id, device, callback) => {
    orion.patch(`entities/${id}/attrs?type=info`, device, {
        headers: {
            "x-auth-token": token,
            "FIWARE-Service": "sensor"
        }
    })
        .then(response => {
            callback(response, false);
        })
        .catch(error => {
            handleError(error, callback, (token_n) => UpdateDevice(token_n, id, device, callback));
        })
};


export const CreateDevice = (token, body, callback) => {
    orion.post('entities', body, {
        headers: {
            "x-auth-token": token,
            "FIWARE-Service": "sensor",
            "Content-Type": "application/json"
        }
    })
        .then(response => {
            callback(response, false);
        })
        .catch(error => {
            handleError(error, callback, (token_n) => CreateDevice(token_n, body, callback));
        })
};


export const GetDeviceLog = (token, device, callback) => {
    organizations.get(`logs/sensor/${device}`, {
        headers: {
            "x-auth-token": token
        }
    }).then(response => {
        callback(response.data, false);
    }).catch(error => {
        handleError(error, callback, (token_n) => GetDeviceLog(token_n, device, callback));
    });
};



// WEBPACK FOOTER //
// ./src/requests/devices.js